import React from 'react'
import { useTranslation } from 'react-i18next'
import { Banner } from '@node-space/ui-components'

export const OfflineBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner key="offlineBanner" variant="warning" iconName="WarningCircle">
      {t('errorMessages.errorOffline')}
    </Banner>
  )
}
